import { render, staticRenderFns } from "./TabCard.vue?vue&type=template&id=1d12bd01"
import script from "./TabCard.vue?vue&type=script&lang=js"
export * from "./TabCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports